import { Component, inject } from '@angular/core';
import { PoThemeService } from '@po-ui/ng-components';

@Component({
  standalone: false,
  selector: 'recriar-root',
  template: `<router-outlet></router-outlet>
    <router-outlet name="modal"></router-outlet>`,
})
export class AppComponent {
  private themeService = inject(PoThemeService);

  constructor() {}

  title = 'admin';
}
